class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.expandDesktopItems()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.expandDesktop = this.expandDesktopItems.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!triggerEl) return

    const itemEl = event.target.closest(this.els?.item?.selector)
    if (!itemEl) return

    this.els?.item?.elements.forEach((el) => {
      if (el.dataset.expandDesktop) {
        delete el.dataset.expandDesktop
      }
    })

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }
    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    itemEl.setAttribute('aria-expanded', !currentState)
  }

  expandDesktopItems () {
    this.els?.item?.elements.forEach((el) => {
      if (el.dataset.expandDesktop && window.BAO.MediaBreakpoints.isMd) {
        el.setAttribute('aria-expanded', 'true')
      }
    })
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
